import { B2bRegistrationSuccessView } from 'components/b2b/B2bRegistrationSuccessView/B2bRegistrationSuccessView';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'router/routes';
import { isB2bRegistrationSuccessLocationState } from './b2bRegistrationNavigationState';

export const B2bRegistrationSuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (!isB2bRegistrationSuccessLocationState(location.state)) {
    return <Navigate to={ROUTES.b2bLanding} replace />;
  }

  return <B2bRegistrationSuccessView onNavigateHome={() => navigate(ROUTES.home)} />;
};
